export interface IDancingViewModel {
  chestSize?: number;
  waistSize?: number;
  hipsSize?: number;
  insideLegSize?: number;
  insideArmSize?: number;
  collarSize?: number;
  hatSize?: number;
  shoeSize?: number;
  dressSize?: number;
  weight?: number;
}
export const IDancingViewModelKeys = [
  "chestSize",
  "waistSize",
  "hipsSize",
  "insideLegSize",
  "insideArmSize",
  "collarSize",
  "hatSize",
  "shoeSize",
  "dressSize",
  "weight",
];
